import * as React from "react";
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {Badge} from "react-bootstrap";
import {Tooltip} from 'primereact/tooltip';
import moment from 'moment';

import {history} from "../router";
import {FORMS_URL} from '../router/urls';
import {getProcessStatus} from "../helpers";
import {copyForm, deleteForm, revokeForm, welcome as welcomeAction} from "../actions";

import LoadingDots from "./ui/LoadingDots";
import HistoryStatusModal from './program/history/';
import ConfirmModal from "../modules/metajson-sub/src/core/modal/ConfirmModal";

class RequestList extends React.Component {
  modal;
  revokeModal;

  constructor() {
    super();
    this.modal = HistoryStatusModal;
    this.revokeModal = ConfirmModal;
  }

  welcome = (process_id, form_type) => (event) => {
    event.stopPropagation();
    const project = form_type === 'request_mentor' ? 'mentorship' : 'consultancy'

    welcomeAction({request_id: process_id, project}, {
      success: () => {
        window.location.pathname = '/planner/'
      },
      error: () => {
        window.location.pathname = '/planner/'
      }
    });
  }

  onFeedback = (form_link) => (event) => {
    event.stopPropagation();
    event.preventDefault();

    window.location.href = form_link;
  }

  goForm = (opts) => (event) => {
    event.stopPropagation();
    event.preventDefault();

    const {form_type, process_id} = opts;

    history.push(FORMS_URL({form_type, process_id}))
  }

  onDelete = (form_type, process_id) => (event) => {
    event.stopPropagation();
    event.preventDefault();

    this.props.deleteForm(form_type, process_id);
  }

  onCopy = (event, form_type, process_id) => (event) => {
    event.stopPropagation();
    event.preventDefault();

    this.props.copyForm(form_type, process_id);
  }

  onModalRevoke = (form_type, process_id) => (event) => {
    event.stopPropagation();
    event.preventDefault();

    this.revokeModal.show(form_type, process_id);
  }

  showHistory = (request) => (event) => {
    event.stopPropagation();
    event.preventDefault();
    this.modal.show(request);
  }

  render() {
    const { forms, mode, loaders } = this.props;
    const mentorshipStatues = [15, 30, 40, 50]
    const consultancyStatues = [30, 40, 50]

    return (
      <LoadingDots show={typeof loaders['forms'] !== 'undefined' || !this.props.modeLoaded}>
        { forms.length > 0 && (
          <div className='table-responsive text-block'>
            <table className='table table-bordered table-hover request-list'>
              <thead>
                <tr>
                  <td>ID</td>
                  <td>Рег. №</td>
                  <td>Дата</td>
                  <td>Участники</td>
                  {mode === 'working'
                    &&
                    <>
                      <td>Статус</td>
                      <td>Операции</td>
                    </>
                  }
                </tr>
               </thead>
               <tbody>
               {forms.sort((a,b)=>{return a.process_id < b.process_id ? 1 : -1}).map(item => (
                  <tr className={`report-list-group request-${item.process_id}`} key={item.process_id + item.form_type} onClick={this.goForm({form_type: item.form_type, process_id: item.process_id})}>
                    <td className='label-num-cell'><span className="no-desktop">№&nbsp;</span>{item.process_id || ''}</td>
                    <td><span className="no-desktop">Рег.№&nbsp;</span> {item.registration_number || ''}</td>
                    <td><span className="no-desktop">Дата:&nbsp;</span> {moment(item.form_date).format('DD.MM.YYYY')}</td>
                    <td className='label-num-cell mentors'>
                      <Badge style={!item?.mentors?.length ? {background: '#d9534f'} : null}>
                        {item?.mentors?.length ?? 0}
                      </Badge>
                      <Tooltip
                        target={`.request-${item.process_id} .mentors`}
                        autoHide={false}
                        position='top'
                        className='mentor-tooltip'
                      >
                        {item?.mentors?.map(mentor => (<span>{mentor}</span>))}
                        {!item?.mentors?.length && (<span>Список пуст</span>)}
                      </Tooltip>
                    </td>
                    {mode === 'working'
                    &&
                    <>
                      <td>
                        <div className="btn-group-vertical" role="group">
                            <label className="btn btn-primary">{getProcessStatus(item)}</label>
                            <button type="button" className="btn btn-success" onClick={this.showHistory(item.process_id)}>История</button>
                        </div>
                      </td>
                      <td>
                        {item.form_status === 0 &&
                          <button className="btn btn-danger btn-xs" onClick={this.onDelete(item.form_type, item.process_id)} title="Удалить">
                            <span className="glyphicon glyphicon-remove" />
                          </button>
                        }
                        &nbsp;
                        {
                          ![0, 10, 11, 80, 90, 99].includes(item.form_status) &&
                          <button className="btn btn-primary btn-xs" onClick={this.onModalRevoke(item.form_type, item.process_id)} title="Отозвать">
                            <span className="glyphicon glyphicon-arrow-left" />
                          </button>
                        }
                        &nbsp;
                        {(item.project_id === "mentorship" ? mentorshipStatues : consultancyStatues).includes(item.form_status) && (
                          <a
                            className="btn btn-primary btn-xs"
                            onClick={this.welcome(item.process_id, item.form_type)}
                            title="Запланировать встречу"
                          >
                            Запланировать встречу
                          </a>
                        )}
                        &nbsp;
                        {item.form_status === 80 && (
                          <a
                            className="btn btn-primary btn-xs"
                            onClick={this.onFeedback(item.form_link)}
                            title="Закрыть/Возобновить"
                          >
                            Закрыть/Возобновить
                          </a>
                        )}
                      </td>
                    </>}
                  </tr>
                ))}
               </tbody>
            </table>
            <HistoryStatusModal ref={(modal) => this.modal = modal }/>
            <ConfirmModal ref={(modal) => this.revokeModal = modal} func={this.props.revokeForm} />
          </div>
        )}
        {forms.length === 0 && (
          <div className='text-block text-block_empty'>
            Не найдено ни одной заявки
          </div>
        )}
      </LoadingDots>
    )
  }
}

RequestList.propTypes = {
  forms: PropTypes.array.isRequired,
  flows: PropTypes.array,
  loaders: PropTypes.shape({}).isRequired,
};

RequestList.defaultProps = {
  flows: []
}

const mapDispatchToProps = {
  copyForm,
  deleteForm,
  revokeForm
};

function mapStateToProps(state) {
  return {
    mode: state.forms.mode,
    forms: state.forms.forms,
    loaders: state.forms.loaders,
    modeLoaded: state.forms.modeLoaded,
    flows: state.forms.flows
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestList);
